/**
 * SHOP_PUBLIC_COLUMNS — columns the anon key is allowed to SELECT.
 *
 * SEC-001 fix: the shops table's blanket SELECT grant to anon was
 * dropped in the security-launch-blockers migration and re-granted
 * only for the columns listed here. `.select('*')` from anon now
 * returns 401 because it would include stripe_* / subscription_* /
 * trial_* fields.
 *
 * Every anon-facing page that reads shops MUST use this list.
 * Authenticated pages (ShopProfile, AppShell, etc.) can continue to
 * use `.select('*')` — RLS + the backend still gate their reads.
 */
export const SHOP_PUBLIC_COLUMNS = [
  'id',
  'name',
  'subdomain',
  'tagline',
  'welcome_text',
  'logo_url',
  'accent_colour',
  'hero_image_url',
  'hero_opacity',
  'gallery_urls',
  'theme',
  'address',
  'address_line_1',
  'address_line_2',
  'city',
  'postcode',
  'email',
  'phone',
  'social_links',
  'opening_hours',
  'show_hours',
  'plan',
  'allow_choose_barber',
  'deposit_required',
  'deposit_amount',
  'deposit_type',
  'in_shop_payment',
  'extra_barbers',
  'reviews',
  'reviews_source',
  'google_place_id',
  'onboarding_completed_at',
  'created_at',
].join(',');
